const mixin = {
    props: {
        providersSetter: String,
    },
}

export default mixin
